import React, { useEffect, useState } from "react";
import { FaEye, FaEnvelope, FaBell, FaPaperPlane ,FaArrowRight} from "react-icons/fa";
import "preline/preline";
import Header from "./Header";
import Footer from "./Footer";
import Tree from "./Tree";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LeftPanel from "./LeftPanel";
import {
  FaSearch
 
} from "react-icons/fa";
const BulkReporting = () => {
  const [email, setEmail] = useState("");
  const [emails, setEmails] = useState([]);
  const [reportType, setReportType] = useState("Bill Validation");
  const [reportingPeriod, setReportingPeriod] = useState("Month");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    if (
      window.HSStaticMethods &&
      typeof window.HSStaticMethods.autoInit === "function"
    ) {
      window.HSStaticMethods.autoInit();
    }
  }, []);

  const handleEmailKeyDown = (e) => {
    if (e.key === "Enter" && email.trim()) {
      e.preventDefault();

      // Regular Expression for Email Validation
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!emailPattern.test(email)) {
        setEmailError("Invalid email address");
        return;
      }

      if (emails.includes(email.trim())) {
        setEmailError("Email already added");
        return;
      }

      setEmails([...emails, email.trim()]);
      setEmail("");
      setEmailError(""); // Clear error if valid email
    }
  };

  const removeEmail = (index) => {
    setEmails(emails.filter((_, i) => i !== index));
  };

  return (
    
    // <div className="min-h-screen flex flex-col font-sans bg-gray-50">
    //   {/* Main Content */}
      
    //   <div className="w-full mx-auto max-w-7xl mb-10 mt-10 gap-2">
    <div className="min-h-screen flex flex-col bg-gray-50 font-[system-ui]">
    
      
    <div className="flex flex-grow">
    <div className="w-[20%]"></div>
    
    <LeftPanel title="REPORTS" />
     
      <div className="w-[60%] px-6 py-8 overflow-y-auto">
      <div className="flex justify-end">
          <div className="flex items-center mb-6">
            <button className="bg-[#7ABC32] text-white px-3 py-1 rounded-l-md">
              Search by Account
            </button>
            <div className="relative w-80">
              <input
                type="text"
                placeholder="Account Number or NMI/Meter"
                className="w-full sm:w-90 px-3 py-1 border rounded-r-md focus:outline-none focus:ring-0 focus:ring-[#7ABC32] italic"
              />
              <FaSearch
                className="absolute right-1 top-2.5 text-blue-500 cursor-pointer"
                size={15}
                title="Search"
              />
            </div>
          </div>
        </div>
    
        <div className="rounded-2xl shadow-sm w-full overflow-hidden">
         
          <div className="flex flex-row gap-4">
        
          
            {/* Right Side: Controls & Actions */}
            <div className="w-full  bg-white p-8 rounded-xl shadow-sm border border-gray-200">
              {/* Right side content */}
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                Generate Reports
              </h2>

              {/* Report Selection */}
              <label className="block text-gray-700 font-medium text-sm mb-1">
                Report
              </label>
              <select
                className="w-full p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-300 ease-in-out"
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
              >
                <option>Bill Validation</option>
                <option>Energy Management</option>
                <option>Interval Data</option>
                <option>Contracts Expiry</option>
              </select>

              {/* Reporting Period */}
              <label className="block text-gray-700 font-medium text-sm mt-6 mb-1">
                Reporting Period
              </label>
              <select
                className="w-full p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-300 ease-in-out"
                value={reportingPeriod}
                onChange={(e) => setReportingPeriod(e.target.value)}
              >
                <option>Month</option>
                <option>Last 6 Months</option>
                <option>Last 12 Months</option>
                <option>This Year</option>
                <option>Last Year</option>
              </select>

              {reportingPeriod === "Month" && (
                <div className="mt-4">
                  <label className="block text-gray-700 font-medium text-sm mt-6 mb-1">
                    Select Month & Year
                  </label>
                  <DatePicker
                    selected={selectedMonth}
                    onChange={(date) => setSelectedMonth(date)}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    className="w-full p-2 border text-sm border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-300 ease-in-out"
                    placeholderText="Select a month and year"
                  />
                </div>
              )}

              {/* Date Picker and Action Buttons in One Line */}
              <div className="flex gap-4 mt-4 mb-5 justify-center items-center">
                <div className="flex gap-4 justify-center items-center">
                  <button className="w-full md:w-auto px-5 py-2.5 bg-[#002060] text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 transition-colors">
                    <FaEye /> View Report
                  </button>
                  {reportType !== "Contracts Expiry" && (
                    <>
                      <button className="w-full md:w-auto px-5 py-2.5 bg-[#002060] text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 transition-colors">
                        <FaEnvelope /> Email Report
                      </button>
                      <button className="w-full md:w-auto px-5 py-2.5 bg-[#002060] text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 transition-colors">
                        <FaBell /> Subscribe
                      </button>
                    </>
                  )}
                </div>
              </div>

              {/* Email Input in a Single Line */}
              {reportType !== "Contracts Expiry" && (
                <div className="w-full">
                  <div className="flex items-center gap-4 mb-2">
                    <label className="text-gray-700 font-medium text-sm">
                      Email Address
                      <span className="text-gray-500 text-xs block">
                        (press Enter to add multiple emails)
                      </span>
                    </label>
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyDown={handleEmailKeyDown}
                      className="flex-1 md:w-3/4 p-2 text-sm border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-500 transition duration-300 ease-in-out hover:border-blue-500"
                      placeholder="Enter email addresses"
                    />
                    {/* <button className="flex justify-center items-center gap-2 px-6 py-3 bg-blue-500 text-white rounded-xl hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all shadow-lg hover:shadow-xl">
                     
                    </button> */}
                    <button className="w-full md:w-auto px-5 py-2.5 bg-[#002060] text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 transition-colors">
                      <FaPaperPlane /> Send Report
                    </button>
                  </div>
                  <div className="mt-2 w-1/2">
                    {emailError && (
                      <p className="text-red-500 text-sm mt-1">{emailError}</p>
                    )}
                  </div>
                  <div className="mt-2 w-1/2">
                    {emails.map((email, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-center p-3 bg-gray-100 rounded-lg mt-2 shadow-sm hover:bg-gray-200 transition-all"
                      >
                        <span className="text-gray-700">{email}</span>
                        <button
                          onClick={() => removeEmail(index)}
                          className="text-red-500 font-semibold hover:text-red-700 transition duration-200"
                        >
                          X
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-full mt-5  bg-white p-2 rounded-xl shadow-sm border border-gray-200">
  {/* Right side content */}
  <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center justify-center space-x-2">
    <span >Go To Accounts</span>
    <svg width="50" height="24" viewBox="0 0 80 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0" y1="12" x2="60" y2="12" stroke="#002060" strokeWidth="4" />
    <polygon points="60,4 80,12 60,20" fill="#002060"  />
  </svg>
   
  
  </h2>
</div>

      </div>
      <div className="w-[20%]"></div>
      </div>
      
    </div>
    
  );
};

export default BulkReporting;
